import React from "react";

/** Physics atom — Figma 18355:110536 */
export const PhysicsIcon = ({ className = "", size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M15.3219 10C17.2477 7.29609 18.2297 4.50156 16.8641 3.13594C15.4984 1.77031 12.7039 2.75234 10 4.67812C7.29609 2.75234 4.50156 1.77031 3.13594 3.13594C1.77031 4.50156 2.75234 7.29609 4.67813 10C2.75234 12.7039 1.77031 15.4984 3.13594 16.8641C3.57578 17.3039 4.16328 17.5 4.84766 17.5C6.29141 17.5 8.16641 16.6273 10.0039 15.3219C11.8336 16.6273 13.7086 17.5 15.1562 17.5C15.8406 17.5 16.4289 17.3031 16.868 16.8641C18.2297 15.4984 17.2477 12.7039 15.3219 10ZM15.9805 4.01953C16.5773 4.61641 16.1742 6.55078 14.5336 8.96328C14.0146 8.32077 13.462 7.70611 12.8781 7.12187C12.2938 6.53883 11.6792 5.98702 11.0367 5.46875C13.4492 3.82812 15.3836 3.42187 15.9805 4.01953ZM13.7727 10C13.2198 10.6993 12.6261 11.3654 11.9945 11.9945C11.3654 12.6261 10.6993 13.2198 10 13.7727C9.30065 13.2198 8.63464 12.6261 8.00547 11.9945C7.37392 11.3654 6.78018 10.6993 6.22734 10C7.33649 8.60232 8.60232 7.33649 10 6.22734C10.6993 6.78018 11.3654 7.37392 11.9945 8.00547C12.6261 8.63464 13.2198 9.30065 13.7727 10ZM4.01953 4.01953C4.19141 3.84687 4.475 3.75781 4.84922 3.75781C5.77266 3.75781 7.24688 4.29687 8.9625 5.46875C8.32065 5.98744 7.70628 6.53923 7.12188 7.12187C6.53883 7.70617 5.98702 8.32083 5.46875 8.96328C3.82812 6.55078 3.42266 4.61641 4.01953 4.01953ZM4.01953 15.9805C3.42266 15.3836 3.82812 13.4492 5.46875 11.0367C5.98778 11.6792 6.54037 12.2939 7.12422 12.8781C7.70813 13.4607 8.32199 14.0125 8.96328 14.5312C6.55078 16.1719 4.61641 16.5781 4.01953 15.9805ZM15.9805 15.9805C15.3836 16.5781 13.4492 16.1742 11.0367 14.5336C11.6789 14.0141 12.2935 13.4616 12.8781 12.8781C13.4612 12.2938 14.013 11.6792 14.5312 11.0367C16.1719 13.4492 16.5773 15.3836 15.9805 15.9805ZM10.9375 10C10.9375 10.1854 10.8825 10.3667 10.7795 10.5208C10.6765 10.675 10.5301 10.7952 10.3588 10.8661C10.1875 10.9371 9.99896 10.9557 9.8171 10.9195C9.63525 10.8833 9.4682 10.794 9.33709 10.6629C9.20598 10.5318 9.11669 10.3648 9.08051 10.1829C9.04434 10.001 9.06291 9.81254 9.13386 9.64123C9.20482 9.46993 9.32498 9.32351 9.47915 9.2205C9.63332 9.11748 9.81458 9.0625 10 9.0625C10.2486 9.0625 10.4871 9.16127 10.6629 9.33709C10.8387 9.5129 10.9375 9.75136 10.9375 10Z"
      fill="currentColor"
    />
  </svg>
);

/** Chemistry flask — Figma 18355:110542 */
export const ChemistryIcon = ({ className = "", size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 15 15.625"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M14.8171 13.732L9.99757 5.69687V1.25H10.6226C10.7883 1.25 10.9473 1.18415 11.0645 1.06694C11.1817 0.949731 11.2476 0.79076 11.2476 0.625C11.2476 0.45924 11.1817 0.300268 11.0645 0.183058C10.9473 0.065848 10.7883 0 10.6226 0H4.37258C4.20682 0 4.04784 0.065848 3.93063 0.183058C3.81342 0.300268 3.74758 0.45924 3.74758 0.625C3.74758 0.79076 3.81342 0.949731 3.93063 1.06694C4.04784 1.18415 4.20682 1.25 4.37258 1.25H4.99758V5.69687L0.178045 13.732C0.0643761 13.9215 0.0029775 14.1378 0.000105592 14.3588C-0.00276631 14.5797 0.0529911 14.7975 0.161696 14.9899C0.270401 15.1823 0.428168 15.3424 0.618921 15.454C0.809673 15.5656 1.02659 15.6246 1.24758 15.625H13.7476C13.9688 15.625 14.186 15.5663 14.3771 15.4549C14.5681 15.3435 14.7262 15.1834 14.8352 14.9909C14.9442 14.7984 15.0002 14.5805 14.9974 14.3593C14.9946 14.1382 14.9332 13.9217 14.8195 13.732H14.8171ZM6.15851 6.19141C6.21697 6.09452 6.24777 5.98347 6.24758 5.87031V1.25H8.74758V5.87031C8.74738 5.98347 8.77818 6.09452 8.83664 6.19141L11.8226 11.1719C10.8851 11.357 9.55148 11.2789 7.77961 10.382C6.53664 9.75312 5.35383 9.41953 4.24679 9.38125L6.15851 6.19141ZM1.24758 14.375L3.47726 10.6578C4.59054 10.5219 5.84523 10.8023 7.2132 11.4953C8.69758 12.2461 9.94758 12.5016 10.9632 12.5016C11.4797 12.5038 11.994 12.4328 12.4905 12.2906L13.7476 14.375H1.24758Z"
      fill="currentColor"
    />
  </svg>
);

/** Maths operators — Figma 18355:110546 */
export const MathsIcon = ({ className = "", size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 15 14.375"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.25 2.5H3.75V0H2.5V2.5H0V3.75H2.5V6.25H3.75V3.75H6.25V2.5ZM0 9.375H6.25V10.625H0V9.375ZM0 12.5H6.25V13.75H0V12.5ZM8.75 2.5H15V3.75H8.75V2.5ZM12.7562 11.25L15 9.00625L14.1188 8.125L11.875 10.3688L9.63125 8.125L8.75 9.00625L10.9938 11.25L8.75 13.4938L9.63125 14.375L11.875 12.1312L14.1188 14.375L15 13.4938L12.7562 11.25Z"
      fill="currentColor"
    />
  </svg>
);

/** Biology leaf — NEET subject tab */
export const BiologyIcon = ({ className = "", size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 2.5C13.5 2.5 17 5.2 17 9.5C17 13.2 14.2 16.2 10.8 17.3C10.55 17.38 10.28 17.25 10.2 17C10.12 16.75 10.25 16.48 10.5 16.4C13.35 15.48 15.5 13 15.5 9.5C15.5 6.05 12.85 4 10 4C7.15 4 4.5 6.05 4.5 9.5C4.5 13 6.65 15.48 9.5 16.4C9.75 16.48 9.88 16.75 9.8 17C9.72 17.25 9.45 17.38 9.2 17.3C5.8 16.2 3 13.2 3 9.5C3 5.2 6.5 2.5 10 2.5Z"
      fill="currentColor"
    />
    <path
      d="M10 5.5V16.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M10 8.5C11.8 8.1 13.2 7.2 14 6"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M10 11.5C8.2 11.1 6.8 10.2 6 9"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

export const resolveSubjectIconComponent = (subject = {}) => {
  const name = String(subject.name || subject.id || "").toLowerCase();
  if (name.includes("physics")) return PhysicsIcon;
  if (name.includes("chem")) return ChemistryIcon;
  if (name.includes("bio")) return BiologyIcon;
  if (name.includes("math")) return MathsIcon;
  return PhysicsIcon;
};
